SupportV2SelectDifferentOrderMenuView = require('./v2_select_different_order_menu_view')

class SupportVerticalSelectDifferentOrderMenuView extends SupportV2SelectDifferentOrderMenuView


  toDetailHash: () ->
    hash = SupportV2SelectDifferentOrderMenuView::toDetailHash.call(this)
    hash.showVerticalView = true
    hash

module.exports = SupportVerticalSelectDifferentOrderMenuView
